const Colors = ["#4285F4", "#EA4335", "#FBBC04", "#34A853", "#FF6D01", "#46BDC6", "#7BAAF7", "#F07B72", "#996635", "#14a9ad"];

export default Colors;
